<table mat-table [dataSource]="dataSource">
  <!-- Name Column -->
  <ng-container matColumnDef="LE004">
    <th mat-header-cell *matHeaderCellDef class="sticky-column sticky-column-1" mwlResizable> 條件/股票 </th>
    <td mat-cell *matCellDef="let item" style="height: 50px;width: 160px;"> {{item.LE004}} <br/><br/> {{item.LE006}} </td>
  </ng-container>
  <ng-container matColumnDef="LE013">
    <th mat-header-cell *matHeaderCellDef mwlResizable> 股價 </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;width: 30px;"> {{item.LE013}} </td>
  </ng-container>
  <ng-container matColumnDef="LE012">
    <th mat-header-cell *matHeaderCellDef mwlResizable> 已說 </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;width: 12px;"> {{item.LE012}} </td>
  </ng-container>
  <ng-container matColumnDef="LE002">
    <th mat-header-cell *matHeaderCellDef mwlResizable> 時間 </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;width: 80px;"> {{item.LE002}} </td>
  </ng-container>
</table>
